import { Pipe, PipeTransform } from '@angular/core';
import { LocalSort, sortRows } from '../util/local-sort';

/** Rows of a local table sorted, see `sortRows`. */
@Pipe({
  name: 'sortRows',
  standalone: false,
})
export class SortRowsPipe implements PipeTransform {
  transform<T>(rows: T[] | null, sort: LocalSort | null): T[] {
    return sortRows(rows, sort);
  }
}
